// extracted by mini-css-extract-plugin
module.exports = {"page":"QrCodeForOrganization_page__1_yX6","wrapper":"QrCodeForOrganization_wrapper__2C5_W","text":"QrCodeForOrganization_text__3yjmK"};